module.exports = {
  ShanghaiPort: 'ท่าเรือเซี่ยงไฮ้',
  QingdaoPort: 'ท่าเรือชิงเต่า',
  DeletionGuide: 'คู่มือการแก้ไขและลบ',
  BusinessData: 'ข้อมูลธุรกิจ',
  DropOffGoods: 'การยกเลิกการขนส่งสินค้า',
  CounterDeletion: 'การยกเลิกเอกสารที่เคาน์เตอร์',
  CertificateOfNonBoarding: 'หนังสือรับรองการไม่ได้ขึ้นเรือ',
  CarrierName: 'ชื่อตัวแทนเรือ',
  Text1: 'ขอบเขตการให้บริการ (แพลตฟอร์มสนับสนุน',
  Text2: 'บริษัทเรือ',
  Text3: 'การส่งใบรายการสินค้าของตัวแทนเรือ รายการดังนี้:)',
  Text4: 'คู่มือการจัดการเกี่ยวกับ "การแก้ไขหรือลบใบรายการสินค้าที่เตรียมไว้ล่วงหน้า"',
  Title1: 'ขอบเขตการให้บริการ — แพลตฟอร์มสนับสนุน',
  Title2: 'การส่ง VGM ของบริษัทเรือ รายการดังนี้:',
  Remark1: 'เซี่ยงไฮ้เจิ้นหัว (ตัวแทนเรือ)',
  Remark2: 'ห้าม Dongjin DJS, Antong ONTO, Datong EAS, Fan Zhou PCS',
  Remark3: 'เซี่ยงไฮ้หมินเซิง (ตัวแทนเรือ)',
  Remark4: 'ห้ามเส้นทางไต้หวันและญี่ปุ่นของบริษัทเรือหมินเซิง ส่วนเส้นทางไต้หวันของ Wan Hai WHL สามารถส่งได้',
  Remark5: 'จินเฉิง (ตัวแทนเรือ)',
  Remark6: 'ห้าม Jin Jiang Shipping JJ',
  Remark7: 'เจิ้งลี่ (บริษัทเรือ)',
  Remark8: 'สำหรับเส้นทางไต้หวันของ "CNC—เจิ้งลี่" โปรดเลือกรหัสบริษัทเรือเป็น "CST—เป่าหัว"',
  Remark9: 'ซินตง (บริษัทเรือ)',
  Remark10: 'สำหรับเส้นทางอินชอนเกาหลีของ "NOS—ซินตง" โปรดเลือกรหัสบริษัทเรือเป็น "NSI—หนิงโปโอเชียน"',
  Remark11: 'สิงคโปร์โอเชียน (บริษัทเรือ)',
  Remark12: 'แบรนด์ย่อยของบริษัทเรือ Bian Hang หมายเลขใบตราส่งที่ขึ้นต้นด้วย SEC สามารถส่งได้ โปรดเลือกบริษัทเรือเป็น "SCO—สิงคโปร์โอเชียน"',
  Remark13: 'สิงคโปร์ซีลีด (บริษัทเรือ)',
  Remark14: 'FCSL-Volta UAE เป็นตัวแทนของ VOLTA ที่เซี่ยงไฮ้ โปรดเลือกบริษัทเรือเป็น "SLS—สิงคโปร์ซีลีด"',
  Remark15: 'เซี่ยงไฮ้ Zhong Lian (ตัวแทนเรือ)',
  Remark16: 'ห้าม Zhong Lian CUL และท่าเรือ Rizhao RPS',
  Remark17: 'ก่อนเรือออก ยังไม่เกินเวลากำหนดส่งใบรายการสินค้าของตัวแทนเรือ และยังไม่ได้ดำเนินการศุลกากรทั้งชุด:',
  Remark18: 'a) หากต้องการแก้ไขบริษัทเรือ ตัวแทนเรือ หมายเลขใบตราส่ง ชื่อเรือ เที่ยวเรือ หมายเลขตู้ หมายเลขซีล ชื่อสินค้า หรือประเภทตู้: ต้องเลือกใบรายการสินค้าเดิมใน "ที่ส่งแล้ว" ยื่นคำขอลบใบรายการสินค้า รอการลบเสร็จสิ้น แล้วจึงส่งใบรายการสินค้าใหม่; สำหรับประเภทตู้ หากผิดเฉพาะตัวแทนเรือ 4 แห่งคือ Zhong Lian/OOCL/Sinotrans/Zhenhua ต้องลบก่อน ส่วนอื่นๆสามารถส่งคำขอแก้ไขได้ทันที',
  Remark19: 'b) หากต้องการแก้ไขข้อมูลอื่นนอกจาก 9 ประเภทข้างต้น สามารถเลือกใบรายการสินค้าใน "ที่ส่งแล้ว" ยื่นคำขอแก้ไขใบรายการสินค้า และรอใบรับรองการแก้ไข',
  Remark20: 'c) สำหรับการรวมตู้ (LCL):',
  Remark21: 'i) หากต้องการแก้ไขข้อมูลบางส่วนของใบตราส่ง ให้ปฏิบัติตามข้อ b ข้างต้น',
  Remark22: 'ii) หากต้องการลบบางส่วนของใบตราส่ง ต้องลบใบรายการสินค้าทั้งหมดที่ใช้หมายเลขตู้เดียวกันก่อน แล้วจึงส่งใบรายการสินค้าใหม่',
  Remark23: 'iii) หากต้องการเพิ่มใบตราส่งรวม สามารถส่งใบตราส่งนั้นได้ทันที (เมื่อตัวแทนเรือเป็น Hanghua หรือ Penghua ต้องบันทึกหมายเลขใบตราส่งย่อยพร้อมกับใบหลักและส่งพร้อมกัน)',
  Remark24: 'ก่อนเรือออก แต่เกินเวลากำหนดส่งใบรายการสินค้าของตัวแทนเรือ หรือลูกค้าได้ดำเนินการศุลกากรแล้ว:',
  Remark25: 'a) หากลูกค้าได้ดำเนินการศุลกากรแล้ว ต้องยกเลิกการตรวจสอบศุลกากรก่อน',
  Remark26: 'b) ติดต่อตัวแทนเรือที่เกี่ยวข้องเพื่อสอบถามวิธีการลบหรือแก้ไข (สามารถสอบถามฝ่ายบริการลูกค้าของเราได้)',
  Remark27: 'c) หากได้รับการปล่อยผ่านแล้ว ต้องส่งเอกสารกระดาษไปที่เคาน์เตอร์ตัวแทนเรือเพื่อยกเลิกสถานะ "ปล่อยผ่านแล้ว" (สามารถสอบถามฝ่ายบริการลูกค้าของเราได้)',
  Remark28: 'หลังจากเรือออกแล้ว ขอยกเลิกเอกสาร:',
  Remark29: 'a) หากลูกค้าได้ดำเนินการศุลกากรแล้ว ต้องยกเลิกใบแจ้งศุลกากรก่อน',
  Remark30: 'b) ต้องส่งเอกสารกระดาษไปที่เคาน์เตอร์ตัวแทนเรือเพื่อดำเนินการลบเอกสาร โดยทั่วไปต้องมีเอกสารอย่างน้อย 4 ชนิด (สำหรับอ้างอิงเท่านั้น): "ใบคำขอลบเอกสาร", "ใบแจ้งศุลกากร", "คำอธิบายสถานการณ์การลบเอกสาร", "ภาพหน้าจอแสดงสถานะการตรวจสอบจากเว็บไซต์ข้อมูลศุลกากร" (บริษัทเราสามารถให้บริการ代办ได้ โปรดสอบถามฝ่ายบริการลูกค้า)',
  Remark31: 'ภาคผนวก: ที่อยู่บริการเคาน์เตอร์ตัวแทนเรือต่างๆ',
  CompanyName1: 'เซี่ยงไฮ้ Penavico',
  CompanyName2: 'เซี่ยงไฮ้ Sinotrans',
  CompanyName3: 'เซี่ยงไฮ้ United',
  CompanyName4: 'เซี่ยงไฮ้ Huagang',
  CompanyName5: 'เซี่ยงไฮ้ Shunde',
  CompanyName6: 'เซี่ยงไฮ้ ฮางฮัว',
  CompanyName7: 'เซี่ยงไฮ้ เหมิงเซิง',
  CompanyName8: 'เซี่ยงไฮ้ เพิ่งฮัว',
  CompanyName9: 'เซี่ยงไฮ้ เพิ่งไห่',
  CompanyName10: 'เซี่ยงไฮ้ จงเหลียน (จงเหอ)',
  CompanyName11: 'เซี่ยงไฮ้ เจิ้นฮัว',
  CompanyName12: 'ซินไห่',
  CompanyName13: 'จิ้นเฉิง',
  CompanyName14: 'โอเรียนท์ โอเวอร์ซีส์',
  CompanyName15: 'เซี่ยงไฮ้พอร์ต ยูเนี่ยน',
  CompanyName16: 'เซี่ยงไฮ้ จงเหลียน',
  CompanyName17: 'เพิ่งฮัว',
  CompanyAddress1: 'ชั้น 5 หมายเลข 531 ถนนอูซง เขตหงโข่ว',
  CompanyAddress2: 'โถงใหญ่ ชั้น 3 หมายเลข 188 ถนนฟูเจียนจงลู่',
  CompanyAddress3: 'ชั้น 1 หมายเลข 916 ถนนต้าต้าหมิง เขตหงโข่ว',
  CompanyAddress4: 'ห้อง 1601 หมายเลข 501 ถนนต้าต้าหมิง',
  CompanyAddress5: 'ห้อง 2701 หมายเลข 440 ถนนไห่หลุน',
  CompanyAddress6: 'ชั้น 2 หมายเลข 99 ถนนหวงผู่ เขตหงโข่ว',
  CompanyAddress7: 'ชั้น 16 จุนเฟิง อินเตอร์เนชั่นแนล เวลท์ พลาซ่า หมายเลข 1619 ถนนต้าเหลียน',
  CompanyAddress8: 'ห้อง 501, 502, 508 ชั้น 5 อาคาร 1 ตึกจงเทียน หมายเลข 1063 ถนนซื่อผิง เขตหยางผู่',
  CompanyAddress9: 'ห้อง 1807-1809 หมายเลข 700 ถนนเหยียนอันตงลู่',
  CompanyAddress10: 'ชั้น 24 หมายเลข 908 ถนนต้าต้าหมิง เขตหงโข่ว',
  CompanyAddress11: 'ชั้น 21 ฮ่องกงไทย พลาซ่า หมายเลข 700 ถนนเหยียนอันตงลู่',
  CompanyAddress12: 'ชั้น 8 ตึกเซี่ยงไฮ้เจียฮัว ไฟแนนซ์ หมายเลข 133 ถนนเทียนถง เขตหงโข่ว',
  CompanyAddress13: 'ชั้น 8 หมายเลข 1200 ถนนเหยียนอันตงลู่',
  CompanyAddress14: 'ชั้น 20 หมายเลข 841 ถนนเหยียนอันจงลู่'
}
